'use strict'

import 'jquery'
import 'slick-slider'

require('./setup')
require('./global')
require('./ajax')
require('./search')
require('./sections/hero')
require('./sections/top-slider')
require('./sections/horizontal-cats')
require('./sections/open-page-header')



